import { useState, useEffect, useCallback } from 'react'
import { useCadaverService } from 'hooks/useCadaverService'

export const useFormLesoesTraumaticas = ({ idExameRealizado, idCadaver, setLesoesForm, setSvgLesoesForm }) => {
  const cadaverService = useCadaverService()
  const [processandoLesoes, setProcessandoLesoes] = useState(true)
  const [lesoes, setLesoes] = useState([])

  useEffect(() => {
    if (idCadaver) {
      cadaverService.getLesoesCadaver(idExameRealizado, idCadaver, setLesoes, setProcessandoLesoes)
    }
  }, [idCadaver, idExameRealizado])

  useEffect(() => {
    if (setLesoesForm) {
      setLesoesForm(lesoes.map((l) => l))
    }
  }, [lesoes, setLesoesForm])

  const setSVGElements = useCallback(
    (newValue) => {
      if (setSvgLesoesForm) {
        setSvgLesoesForm((prevState) => ({
          ...prevState,
          svgFront: newValue.svgFront,
          svgLeft: newValue.svgLeft,
          svgRight: newValue.svgRight,
          svgBack: newValue.svgBack,
        }))
      }
    },
    [setSvgLesoesForm]
  )

  return {
    processandoLesoes,
    lesoes,
    setLesoes,
    setSVGElements,
  }
}
